import React, { useState } from 'react';
import Link from 'Components/Link/Link';
import PageContent from 'Components/Page/PageContent';
import PageContentBody from 'Components/Page/PageContentBody';
import settingsStyles from 'Settings/Settings.css';
import SettingsToolbar from '../components/SettingsToolbar';
import { getAdvancedSettings, setAdvancedSettings, settingsSections } from '../settings';

export default function Settings() {
  const [advanced, setAdvanced] = useState(getAdvancedSettings);
  const toggleAdvanced = () => {
    setAdvanced((current) => {
      setAdvancedSettings(!current);
      return !current;
    });
  };
  return <PageContent title="Settings">
    <SettingsToolbar advancedSettings={advanced} onAdvancedSettingsPress={toggleAdvanced} />
    <PageContentBody>
      {settingsSections.map((section) => <React.Fragment key={section.id}>
        <Link className={settingsStyles.link} to={section.to}>{section.title}</Link>
        <div className={settingsStyles.summary}>{section.summary}</div>
      </React.Fragment>)}
    </PageContentBody>
  </PageContent>;
}
